import { TableCell } from '@material-ui/core';
import { Currency, formatMoney } from '@nemuru-eng/js-api-client';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export const TotalAmount = ({
  totalAmount,
  currency,
  isMobile,
  tableProps,
}: {
  totalAmount: number;
  currency: Currency;
  isMobile: boolean;
  tableProps: { stickyCellStyle };
}) => {
  const { stickyCellStyle } = tableProps;
  const { background } = useCustomTheme();

  return isMobile ? (
    <>
      <TableCell
        align={'left'}
        colSpan={1}
        style={{ ...stickyCellStyle, backgroundColor: background, paddingLeft: 36 }}
      >
        <Font variant={'body2'}>
          <Text strong tId={'TOTAL'} />
        </Font>
      </TableCell>
      <TableCell colSpan={3} />
      <TableCell align={'center'} style={{ ...stickyCellStyle, backgroundColor: background, right: 0, left: 120 }}>
        <Font variant={'body2'}>
          <strong>{formatMoney({ value: totalAmount, currency })}</strong>
        </Font>
      </TableCell>
    </>
  ) : (
    <>
      <TableCell align={'left'} colSpan={3}>
        <Font variant={'body2'}>
          <Text strong tId={'TOTAL'} />
        </Font>
      </TableCell>
      <TableCell align={'right'}>
        <Font variant={'body2'}>
          <strong>{formatMoney({ value: totalAmount, currency })}</strong>
        </Font>
      </TableCell>
    </>
  );
};
